import { render, staticRenderFns } from "./resourceType.vue?vue&type=template&id=64903f28"
import script from "./resourceType.vue?vue&type=script&lang=js"
export * from "./resourceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64903f28')) {
      api.createRecord('64903f28', component.options)
    } else {
      api.reload('64903f28', component.options)
    }
    module.hot.accept("./resourceType.vue?vue&type=template&id=64903f28", function () {
      api.rerender('64903f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/basic/resourceType.vue"
export default component.exports